import App from "./src/index";
import {
    createRoot
} from "react-dom/client";

const originalWarn = console.warn;

declare global {
    interface Window {
        deferredPWAInstallPrompt: Event | null;
    }
}

if (typeof window !== "undefined") {
    window.deferredPWAInstallPrompt = null;
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        window.deferredPWAInstallPrompt = e;
    });
}
console.warn = (...args) => {
    if (typeof args[0] === "string" && (
        args[0].includes("pointerEvents") ||
        args[0].includes("useNativeDriver") ||
        args[0].includes("TouchableWithoutFeedback") ||
        args[0].includes("Cannot record touch")
    )) return;
    originalWarn(...args);
};

const rootElement = document.getElementById("app-root");
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
} else {
    console.error("Could not find root element 'app-root' to render the app.");
}

if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
        navigator.serviceWorker.register("/service-worker.js").then((registration) => {
            console.log("SW registered: ", registration);
        }).catch((registrationError) => {
            console.log("SW registration failed: ", registrationError);
        });
    });
}
